import { Box, Typography } from "@mui/material";
import { IPremiumPerVehicle } from "../../../../../models/user/policyDetails/PolicyDetails";
import { PremiunStyles } from "./PremiumStyles";
import { currencyFormat } from "../../../../../utils/Utility";
import { useTranslation } from "react-i18next";

interface IProps {
  perVehicledata: IPremiumPerVehicle[];
  totalPremium: string | null;
}

const Premium = (props: IProps) => {
  const { perVehicledata, totalPremium } = props;

  const { t } = useTranslation();

  const getPerVehicleSection = () => {
    let element: any = <Box>{t("No records found")}</Box>;
    if (perVehicledata && perVehicledata?.length > 0) {
      element = perVehicledata.map((item, index) => {
        return (
          <Box 
            key={`p-v-${index}`} 
            sx={PremiunStyles.vehicleContainer}
            id={`coverages_premium_vehicle_${index}`}
            data-test-id={`coverages_premium_vehicle_${index}`}
            aria-label={`Vehicle ${index + 1} premium information`}
          >
            <Typography 
              sx={PremiunStyles.vehicleLabel}
              id={`coverages_premium_vehicle_amount_${index}`}
              data-test-id={`coverages_premium_vehicle_amount_${index}`}
              aria-label={`Premium amount for vehicle ${index + 1}: ${currencyFormat("us", parseFloat(item.amount))}`}
            >
              {currencyFormat("us", parseFloat(item.amount))}
            </Typography>
            {item.make ? (
              <Typography 
                sx={PremiunStyles.vehicleText}
                id={`coverages_premium_vehicle_details_${index}`}
                data-test-id={`coverages_premium_vehicle_details_${index}`}
                aria-label={`Vehicle ${index + 1} details: ${item.manufactureYr}-${item.make}-${item.model}`}
              >
                {`${item.manufactureYr}-${item.make}-${item.model}`}
              </Typography>
            ) : (
              ""
            )}
          </Box>
        );
      });
    }
    return element;
  };

  return (
    <>
      <Box 
        sx={PremiunStyles.mainBox}
        id="coverages_premium_main_box"
        data-test-id="coverages_premium_main_box"
        aria-label="Premium information section"
      >
        <Box
          sx={{
            ...PremiunStyles.totalPremiumBox,
            borderBottom:
              perVehicledata.length > 1 ? "2px solid rgba(63, 63, 63, 1)" : "",
          }}
          id="coverages_premium_total_box"
          data-test-id="coverages_premium_total_box"
          aria-label="Total premium information"
        >
          <Typography 
            sx={PremiunStyles.totalPremiumLabel}
            id="coverages_premium_total_label"
            data-test-id="coverages_premium_total_label"
            aria-label="Total premium label"
          >
            {t("Total Premium")}
          </Typography>
          <Typography 
            sx={PremiunStyles.totalPremiumText}
            id="coverages_premium_total_amount"
            data-test-id="coverages_premium_total_amount"
            aria-label={`Total premium amount: ${totalPremium ? currencyFormat("us", parseFloat(totalPremium)) : "$0"}`}
          >
            {totalPremium
              ? currencyFormat("us", parseFloat(totalPremium))
              : `$0`}
          </Typography>
        </Box>
        {perVehicledata.length > 1 ? (
          <Box
            id="coverages_premium_per_vehicle_section"
            data-test-id="coverages_premium_per_vehicle_section"
            aria-label="Premium per vehicle section"
          >
            <Typography
              sx={{ ...PremiunStyles.totalPremiumLabel, float: "left" }}
              id="coverages_premium_per_vehicle_label"
              data-test-id="coverages_premium_per_vehicle_label"
              aria-label="Premium per vehicle label"
            >
              {t("Total Premium Per Vehicle")}
            </Typography>
            <Box 
              sx={PremiunStyles.perVehicleBox}
              id="coverages_premium_per_vehicle_container"
              data-test-id="coverages_premium_per_vehicle_container"
              aria-label="Premium per vehicle list"
            >
              {getPerVehicleSection()}
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </>
  );
};
export default Premium;
